module.exports = "<button class=\"btn\" aria-label=\"S'identifier avec FranceConnect\" (click)=\"openFranceConnectPopup()\">\n    <span class=\"sr-only\">S'identifier avec FranceConnect</span>\n</button>\n<p class=\"quote\">Accéder à tous les services en vous connectant avec votre compte ameli.fr, impots.gouv.fr ou\n    ind.laposte.fr, etc.\n    <a href=\"https://app.franceconnect.gouv.fr/en-savoir-plus\" rel=\"noopener noreferrer\" target=\"_blank\"> <span>En savoir plus</span></a>\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/shared/components/franceConnect-button/franceConnect-button.component.html
// module id = 849
// module chunks = 0